<div class="sh-card-table-wrapper" [class.-sh-sticky-columns]="stickyActions && actionItems">
  @if (columns()) {
    <sh-table-head
      [columns]="columns()"
      [columnOptions]="columnOptions()"
      [availableSelect]="availableSelect()"
      [availableDragAndDrop]="availableDragAndDrop()"
      [availableActionItems]="!!actionItems"
      [itemsSelectedLabelKey]="itemsSelectedLabelKey"
      [noItemsSelectedLabelKey]="noItemsSelectedLabelKey"
      [canBatchSelect]="canBatchSelect"
      [selectedItemsCount]="selectedItemsCount"
      [selectedPageItemsCount]="selectedPageItems"
      [totalPageItemsCount]="rowElements?.length ?? 0"
      [isInitialBulk]="isInitialBulk"
      [allowSort]="allowSort()"
      [currentSort]="sortInfo"
      [contextActionGroup]="contextActionGroup"
      [hideColumnHeaders]="hideColumnHeaders"
      (selectionChanged)="onSelectionChanged($event)"
      (sortInfoChanged)="onSortInfoChanged($event)"
      (columnSelectionChanged)="onColumnSelectionChanged($event)"
      (drop)="onParentDrop($event)"
      (dragover)="onParentDragOver($event)"
      (dragleave)="onParentDragLeave($event)"
      >
      <tbody #tbody dndDropzone dndEffectAllowed="move" (dndDrop)="onDrop($event)">
        @if (loading$ | async) {
          <tr id="generic-list-loading-row">
            <td style="width: 2000vw" [attr.colspan]="columnCount()">{{ loadingMsg }}</td>
          </tr>
        }

        @if (hasError && !(loading$ | async)) {
          <tr id="generic-list-error-row" class="sh-card-table__row--error">
            <td style="width: 2000vw" [attr.colspan]="columnCount()">{{ loadingFailedMsg }}</td>
          </tr>
        }

        @if (!hasError && rowElements && !(loading$ | async)) {
          @if (rowElements?.length === 0) {
            <tr id="generic-list-empty-row" class="sh-card-table__row--update">
              <td style="width: 2000vw" [attr.colspan]="columnCount()">{{ emptyListMsg }}</td>
            </tr>
          }
          @for (rowElement of rowElements; track trackByFunction(rowIndex, rowElement); let rowIndex = $index) {
            @defer (when autoRefresh; on viewport; prefetch on idle) {
            @if ({ selected: isRowSelected(rowElement), highlighted: isRowHighlighted(rowElement) }; as data) {
              <tr
                [class.sh-card-table__row--active]="isRowActive(rowElement)"
                [class.sh-card-table__row--selected]="data.selected || data.highlighted"
                [class.-sh-actionable]="areItemsClickable"
                [draggable]="availableDragAndDrop() && !disableDragAndDrop"
                [dndDraggingClass]="'sh-card-table__row--dragging'"
                [dndDisableIf]="!availableDragAndDrop() || disableDragAndDrop"
                [dndDraggable]="rowElement"
                [dndEffectAllowed]="'move'"
                (dndStart)="onDragStart(rowElement)"
                (dndCanceled)="onDragCanceled()"
                (click)="onRowClicked($event, rowElement)"
                (keydown.enter)="onRowClicked($event, rowElement)"
                (dragenter)="onDrag($event)"
                (dragleave)="onDrag($event)"
                (dragend)="onDrag($event)"
                >
                @if (availableDragAndDrop()) {
                  <td
                    [ngClass]="disableDragAndDrop ? 'sh-card-table__col--draggable-icon--disabled' : 'sh-card-table__col--draggable-icon'"
                    dndHandle
                    [title]="dragAndDropTooltip"
                    >
                    <svg sh-icon name="draggable"></svg>
                  </td>
                }
                @if (availableSelect()) {
                  <td class="sh-card-table__col--small">
                    <input
                      class="sh-checkbox"
                      type="checkbox"
                      [checked]="data.selected"
                      [disabled]="disableSelect"
                      [title]="disableSelect ? disableSelectMessage : ''"
                      (click)="onSelectRow($event, rowElement)"
                      (keyup.enter)="onSelectRow($event, rowElement)"
                      />
                  </td>
                }
                @for (columnDefinition of columns(); track columnDefinition; let columnIndex = $index) {
                  <td [width]="columnDefinition.width" [id]="`${columnDefinition.toString()}-${rowIndex}`">
                    <sh-generic-cell
                      [cell]="columnDefinition.mapper(rowElement)"
                      (cellEvent)="onCellEvent($event, rowElement)"
                    ></sh-generic-cell>
                  </td>
                }
                @if (actionItems) {
                  <td [class.sh-sticky-col--end]="stickyActions" class="sh-card-table__col--small">
                    @if (actionItems[rowIndex]; as group) {
                      <sh-action-group
                        [actionGroup]="group"
                        [inOverflownContainer]="true"
                      ></sh-action-group>
                    }
                  </td>
                }
              </tr>
            }
            } @placeholder {
            <tr class="sh-card-table__row--placeholder loading-placeholder">
              <td [attr.colspan]="columnCount()"></td>
            </tr>
          }
        }
      }
      <tr id="dnd-placeholder" class="sh-card-table__row--placeholder" dndPlaceholderRef>
        @if (availableDragAndDrop()) {
          <td class="sh-card-table__col--draggable-icon"></td>
        }
        <td [attr.colspan]="columnCount()"></td>
      </tr>
    </tbody>
  </sh-table-head>
}
</div>
